import { useState, type ReactNode } from 'react';
import { HqStoreContext, HQ_STORE_KEY, readStoredHqStoreNo } from './useHqStore';

export function HqStoreProvider({ children }: { children: ReactNode }) {
  const [storeNo, setStoreNoState] = useState<number | null>(readStoredHqStoreNo);

  function setStoreNo(n: number | null) {
    setStoreNoState(n);
    try {
      if (n !== null) {
        localStorage.setItem(HQ_STORE_KEY, String(n));
      } else {
        localStorage.removeItem(HQ_STORE_KEY);
      }
    } catch {
      // localStorage unavailable — no-op
    }
  }

  return (
    <HqStoreContext.Provider value={{ storeNo, setStoreNo }}>
      {children}
    </HqStoreContext.Provider>
  );
}
